/**
 * Zod schema for the "Invite User" form (Identity / Team Management) — imported by
 * `InviteUserForm.tsx`, never redefined (form-standard.context.md §3). The directory-search
 * combobox (`searchQuery`/`selectedUser`/dropdown) is bespoke UI affordance, not itself part of
 * `CreateInvitationRequest` — it resolves to the same `email` field the schema validates (form-
 * standard.context.md §12, "custom forms still follow this standard").
 */
import { z } from 'zod';
import { TenantRole } from '../types';
import type { CreateInvitationRequest } from '../types';

export const InviteUserSchema = z.object({
  // Required (verbatim messages match the pre-existing UX exactly).
  email: z
    .string()
    .trim()
    .min(1, 'Please search for a user or enter an email address')
    .refine((v) => v.includes('@'), { message: 'Please enter a valid email address' }),
  role: z.nativeEnum(TenantRole),
});

export type InviteUserFormValues = z.input<typeof InviteUserSchema>;
export type InviteUserFormOutput = z.output<typeof InviteUserSchema>;

// Compile-time proof the schema's output + the fixed `tenantId` prop assembles a valid
// CreateInvitationRequest.
type _AssertAssignable = InviteUserFormOutput & { tenantId: string } extends CreateInvitationRequest
  ? true
  : false;
const _assertAssignable: _AssertAssignable = true;
void _assertAssignable;
